(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('StatusCtrl', StatusController);

  StatusController.$inject = [
    '$rootScope',
    '$scope',
    '$location',
    'Flash',
    'MessagesService',
    'ApiGlobalService',
    'CommonHTTPService',
    '$q',
    '$http'
  ];

  function StatusController($rootScope, $scope, $location, Flash, MessagesService, ApiGlobalService, CommonHTTPService, $q, $http) {
    var vm = this;
    var TIMEOUT_LIMIT = 10000;

    //////////////////////////////////////////
    // Controller data
    vm.accessPoints = [];
    vm.loading = true;

    //////////////////////////////////////////
    // Bindable functions
    vm.refresh = LoadAPs;
    vm.checkedAmt = FilterAndCount('loaded');
    vm.onlineAmt = FilterAndCount('online');
    vm.offlineAmt = FilterAndCount('offline');
    vm.offlineAPs = OfflineAPs;
    vm.isOffline = IsOffline;

    //////////////////////////////////////////
    // Function declarations

    function LoadAPs() {
      vm.loading = true;
      vm.accessPoints = [];
      ApiGlobalService.listActive().then(function(result) {
        vm.accessPoints = result;
        $q.all(vm.accessPoints.reduce(GetAPStatus, [])).then(function() {
          vm.loading = false;
        }).catch(function() {
          vm.loading = false;
        });
      }, function() {
        MessagesService.alert('Falha ao carregar informações dos servidores, tente novamente.');
      });
    }

    function GetAPStatus(all, current, index) {
      all.push($q(function(resolve) {
        var start = moment();
        CheckAP(current).then(function(result) {
          vm.accessPoints[index].status = ProcessStatus(result, start);
          vm.accessPoints[index].information = result.data;
          resolve();
        }).catch(function(result) {
          vm.accessPoints[index].status = ProcessStatus(result, start);
          resolve();
        }).finally(function() {
          resolve();
        });
      }));

      return all;
    }

    function CheckAP(client, deferred, attempt) {
      deferred = deferred || $q.defer();
      attempt = attempt || 1;
      var url = client.scheme + '://' + client.host + ':' + client.port_api + '/v1/status';
      client.onlyAgroGestao = !client.systems.includes('aqila');

      if (client.onlyAgroGestao) {
        url = client.url_web;
      }

      $http.get(url, {
        timeout: TIMEOUT_LIMIT
      }).then(deferred.resolve)
        .catch(function(error) {
          if (attempt >= 3) {
            deferred.reject(error);
          } else {
            CheckAP(client, deferred, attempt + 1);
          }
        });


      return deferred.promise;
    }

    function ProcessStatus(result, start) {
      if (CommonHTTPService.isSuccess(result.status) || CommonHTTPService.isNotFound(result.status)) {
        return {
          online: true,
          duration: moment() - start,
          response: result.status
        };
      } else {
        return {
          online: false,
          duration: TIMEOUT_LIMIT,
          response: CommonHTTPService.isTimeout(result.status) ? 'timeout' : result.status
        };
      }
    }

    function FilterAndCount(type) {
      return function() {
        return vm.accessPoints.reduce(function(total, current) {
          if (type === 'online' && current.status && current.status.online) {
            return total + 1;
          } else if (type === 'offline' && current.status && !current.status.online) {
            return total + 1;
          } else if (type === 'loaded' && current.status) {
            return total + 1;
          }

          return total;
        }, 0);
      };
    }

    function OfflineAPs() {
      return vm.accessPoints.filter(function(ap) {
        return vm.isOffline(ap);
      });
    }

    function IsOffline(ap) {
      return ap.status && !ap.status.online;
    }

    //////////////////////////////////////////
    // Controller logic
    $rootScope.bodyClass = 'gray-bg';
    $rootScope.initialize.then(function() {
      if (!($rootScope.permissions.aqila || {}).canManage) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      LoadAPs();
    }, $rootScope.errorRootInitialize);
  }
}());
